import React, { useEffect, useState } from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { useApp } from '../../../contexts/app-context';
import { formService } from '../../../form-service';
import { getCarlines } from '../../../service/api/get-carlines';
import { getExternalContentSalesgroups } from '../../../service/api/get-salesgroups';
import { Carline, Salesgroup } from '../../../types/vehicle-types';
import { SelectExtended } from './core/select-extended';

interface Props {
	label?: string;
	required?: boolean;
	carlines?: Carline[];
	salesgroups?: Salesgroup[];
	carlineCode?: string | number;
}

/*
 * VehicleSelect
 *
 * Se cargan los salesgroups definidos en externalContent. Si no hay ningun salesgroup definido en externalContent se cargan los carlines (filtrados por externalContent).
 *
 */
export function VehicleSelect(props: Props) {
	const { label, carlines, salesgroups, carlineCode } = props;
	const { setAppError, setAppErrorLog } = useApp();
	const [options, setOptions] = useState<{ text: string; value: any }[]>([]);
	const [availableCarlines, setAvailableCarlines] = useState<Carline[]>([]);

	useEffect(() => {
		// Priorizamos la carga de Salesgroups
		if (salesgroups) {
			mapppingSalesgroupOptions(salesgroups);
		}
		if (carlines) {
			mapppingCarlineOptions(carlines);
		} else {
			getExternalContentSalesgroups().then((salesgroups) => {
				if (salesgroups) {
					mapppingSalesgroupOptions(salesgroups);
				} else {
					getCarlines().then((carlines) => {
						if (!carlines) {
							setAppError(true);
							setAppErrorLog('No se ha obtenido ningún carline.');
						} else if (carlines) {
							mapppingCarlineOptions(carlines);
						}
					});
				}
			});
		}
	}, []);

	// Seleccionar cuando carlineCode cambia y tenemos carlines disponibles
	useEffect(() => {
		if (carlineCode && availableCarlines.length > 0) {
			const carline = availableCarlines.find((carline) => String(carline.code) === String(carlineCode));
			if (carline) {
				formService.setFieldValue(FIELD_NAME.CARLINE, carline);
			}
		}
	}, [carlineCode, availableCarlines]);

	const mapppingCarlineOptions = (carlines: Carline[]) => {
		// Mapeamos options <key:text> con carlines ordenamos alfabeticamente y añadiendo "Nuevo"
		const sortedCarlines = [...carlines].sort((a, b) => a.title.localeCompare(b.title));
		const mappedOptions = sortedCarlines.map((carline) => ({
			text: (carline.nuevo ? 'Nuevo ' : '') + carline.title,
			value: carline,
		}));
		setOptions(mappedOptions);
		setAvailableCarlines(sortedCarlines);
	};

	const mapppingSalesgroupOptions = (salesgroups: Salesgroup[]) => {
		// Mapeamos options: text = title, value = name; ordenamos alfabeticamente
		const mappedOptions = salesgroups
			.sort((a, b) => a.title.localeCompare(b.title))
			.map((sg) => ({
				text: sg.title,
				value: sg.name,
			}));
		setOptions(mappedOptions);
	};

	return (
		<SelectExtended
			{...props}
			name={salesgroups ? FIELD_NAME.SALESGROUP : FIELD_NAME.CARLINE}
			label={label ? label : 'Modelo'}
			options={options}
		/>
	);
}
